<template>
  <div class="home">
    <slide-in direction="up">
      <img src="../assets/lorry_wide_banner.jpg" class="big-image" alt="Wide view of Dave Bennett Lorry"/>
    </slide-in>

    <text-and-image :image-width="400">

      <template v-slot:header>About Us</template>

      <template v-slot:image>
        <img src="../assets/db_lorry2.jpeg" class="about-us-lorry__image" alt="Dave Bennett Distribution Lorry"/>
      </template>

      <template v-slot:text>
        <p>Dave Bennett Distribution is ready to provide you with excellent services in container, refrigerated, and curtain-sided transport.</p>
        <p>Our professional team will take care of all your haulage needs and we will provide you with a reliable and fast transport service at remarkably competitive rates.</p>
        <p>Our company is ideally situated to transport your goods from the vital transport links throughout the country.</p>
      </template>

    </text-and-image>

    <text-and-image reversed>

      <template v-slot:header>Our Team</template>

      <template v-slot:text>
        <p>Every employee at Dave Bennett Distribution has years of experience in the transportation industry!</p>
        <p>We first understand your demands and interests and utilise the key attractions in the United Kingdom Haulage Marketplace to deliver you the best haulage service.</p>
        <p>Contact our specialists for more information, as they are always available to solve any issues that you may have.</p>
      </template>

    </text-and-image>

    <text-and-image class="shadowed">
      <template v-slot:image>
        <iframe
          width="100%" height="100%"
          frameborder="0" style="border:0"
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBOsS24ecDTxE68njzy3m_P5NhOvrgtO94&q=dave+bennett+distribution+me11+5pp" allowfullscreen>
        </iframe>
      </template>
      <template v-slot:header>Find Us</template>
      <template v-slot:text>
        <p>Dave Bennett Distribution is located at an ideal place with quick and easy access to the main motorways of the United Kingdom.</p>
        <p>Our company is ideally situated to transport your goods from the vital transport links throughout the country.</p>
        <p>Currently, we are providing our services in Paddock Wood, Tilbury, Sittingbourne, Dover, Portsmouth, and the London Gateway.</p>
        <p>We utilise our excellent location to reduce unloaded miles, provide you better value for money, and reduce overall emissions.</p>
        <div>
          <router-link to="/contact" class="branded-button section-button">Get in touch</router-link>
        </div>
      </template>

    </text-and-image>

  </div>
</template>

<script>
// @ is an alias to /src

import TextAndImage from "@/components/text-and-image";
import SlideIn from "../components/slide-in";
export default {
  name: 'Home',
  components: {
    SlideIn,
    TextAndImage

  }
}
</script>

<style lang="scss" scoped>

  .big-image {
    margin-bottom: 1rem;
    width: 100%;
  }

  .about-us-lorry__image {
    max-height: 500px;
  }

  @media (min-width: 1000px) {
    .about-us-lorry__image {
      max-width: 400px;
      max-height: 400px;
    }
  }

  .our-services {

    &__contact {
      display: flex;
      justify-content: center;
    }
  }

  .section-button {
    margin-top: auto;
  }

</style>
